import React, {useState, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Icon,
  Typography,
  DialogContent,
  Dialog,
  DialogTitle,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import { getAdditionalFeaturesApi } from 'api/subscription';
import FeaturesList from './FeaturesList';
import FeaturesForm from './FeaturesForm';


const Features = () => {
  const dispatch = useDispatch();
  const [feature, setFeature] = useState();

  useEffect(() => {
    getAdditionalFeaturesApi({ dispatch });
  }, []);

  return (
    <Accordion
      elevation={25}
      className="mb-4"
    >
      <AccordionSummary
        expandIcon={<Icon>expand_more</Icon>}
      >
        <Typography variant="h5" className="text-brand m-2" title="Additional Features">Additional Features</Typography>
      </AccordionSummary>
      <AccordionDetails className="block">
        <FeaturesList setFeature={setFeature} />
        <Button
          color="primary"
          variant="contained"
          onClick={() => setFeature({})}
          className="mb-8 ml-4"
        >
          <Icon className="mr-2">add</Icon>
          <span>Add New Feature</span>
        </Button>
        <Dialog
          open={feature}
          onClose={() => setFeature(null)}
          maxWidth={'md'}
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h4" className="mt-4">{feature?._id ? 'Edit Additional Feature' : 'Create Additional Feature'}</Typography>
          </DialogTitle>
          <DialogContent  className="m-4">
            <FeaturesForm feature={feature} setFeature={setFeature} />
          </DialogContent>
        </Dialog>
      </AccordionDetails>
    </Accordion>
  );
};

export default Features;
